// Line icons for the sidebar and toolbars. 24px grid, drawn with stroke so
// they take the text colour. Kept in one place so the set stays consistent.

const paths: Record<string, string> = {
  today: "M4 11.5 12 5l8 6.5V19a1 1 0 0 1-1 1h-4.5v-5h-5v5H5a1 1 0 0 1-1-1z",
  results: "M4 20h16M7 16v-5M12 16V7M17 16v-8",
  inbox: "M4 13h4.5l1.5 2.5h4l1.5-2.5H20M5.5 6h13L20 13v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-5z",
  calendar: "M5 6.5h14a1 1 0 0 1 1 1V19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7.5a1 1 0 0 1 1-1zM4 10.5h16M8.5 4v4M15.5 4v4",
  contacts: "M12 12a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM5 20c.6-3.4 3.3-5.5 7-5.5s6.4 2.1 7 5.5",
  deals: "M4 5h4v14H4zM10 5h4v9h-4zM16 5h4v6h-4z",
  tasks: "M5 7.5 6.5 9 9.5 6M5 15.5 6.5 17l3-3M12.5 7.5H20M12.5 15.5H20",
  automations: "M13 3.5 5.5 13.5H12L11 20.5l7.5-10H12z",
  agents: "M7 8.5h10a2 2 0 0 1 2 2V17a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-6.5a2 2 0 0 1 2-2zM12 4.5v4M9.5 13.5v1M14.5 13.5v1",
  knowledge: "M5 5.5A1.5 1.5 0 0 1 6.5 4H19v13H6.5A1.5 1.5 0 0 0 5 18.5zM5 18.5A1.5 1.5 0 0 0 6.5 20H19M9 8h6",
  channels: "M5 6h14v9H9.5L6 18.5V15H5zM9 10.5h6",
  email: "M4.5 6.5h15a.5.5 0 0 1 .5.5v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a.5.5 0 0 1 .5-.5zM4.5 7l7.5 6 7.5-6",
  team: "M9 11.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM3.5 19c.5-3 2.6-4.8 5.5-4.8s5 1.8 5.5 4.8M16 5.7a3 3 0 0 1 0 5.6M17.5 14.4c1.7.5 2.8 2.1 3 4.6",
  workspace: "M4 7h9M17 7h3M4 17h3M11 17h9M15 5v4M9 15v4",
  services: "M5 6.5h14M5 12h14M5 17.5h9M17.5 15.5v4M15.5 17.5h4",
  "booking-page": "M6 4h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zM8.5 8.5h7M8.5 12h7M8.5 15.5l1.5 1.5 3-3",
  brand: "M12 4a8 8 0 1 0 0 16c1 0 1.5-.7 1.5-1.5 0-1.2-1-1.6-1-2.7 0-.9.7-1.6 1.6-1.6H16a4 4 0 0 0 4-4C20 7 16.4 4 12 4zM7.5 12a1 1 0 1 0 0-.01M10 8a1 1 0 1 0 0-.01M14.5 8a1 1 0 1 0 0-.01",
  security: "M12 3.5 19 6v5.5c0 4.3-2.9 7.6-7 9-4.1-1.4-7-4.7-7-9V6zM9 12l2 2 4-4",
  settings: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19 12l1.6-1.2-1.6-2.8-1.9.6a6.6 6.6 0 0 0-1.5-.9L15.2 5.7h-3.2l-.4 2a6.6 6.6 0 0 0-1.5.9l-1.9-.6L6.6 10.8 8.2 12l-1.6 1.2 1.6 2.8 1.9-.6c.5.4 1 .7 1.5.9l.4 2h3.2l.4-2c.5-.2 1-.5 1.5-.9l1.9.6 1.6-2.8z",
  sparkle: "M12 4.5c.4 3.6 2 5.6 6.5 6.5-4.5.9-6.1 2.9-6.5 6.5-.4-3.6-2-5.6-6.5-6.5 4.5-.9 6.1-2.9 6.5-6.5z",
  help: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM9.8 9.6a2.3 2.3 0 0 1 4.4.9c0 1.6-2.2 1.9-2.2 3.3M12 16.6v.01",
  switch: "M7 7.5h12l-3-3M17 16.5H5l3 3",
  operator: "M4 6h16v10H4zM9 20h6M12 16v4",
  account: "M12 12a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM5 20c.6-3.4 3.3-5.5 7-5.5s6.4 2.1 7 5.5",
  signout: "M14 5h4a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-4M10 8l-4 4 4 4M6 12h9",
  collapse: "M5 5h14v14H5zM10 5v14M15.5 10 13.5 12l2 2",
  expand: "M5 5h14v14H5zM10 5v14M13.5 10l2 2-2 2",
  menu: "M4.5 7h15M4.5 12h15M4.5 17h15",
  close: "M6 6l12 12M18 6 6 18",
  chevron: "M9 6l6 6-6 6",
  back: "M15 6l-6 6 6 6",
  folder: "M4 7a1 1 0 0 1 1-1h4l2 2h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z",
  search: "M10.5 17a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13zM15.2 15.2 20 20",
  dot: "M12 12h.01",
  money: "M4 7h16v10H4zM12 14.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM7 10v.01M17 14v.01",
  plans: "M7 4h10a1 1 0 0 1 1 1v15l-6-3.5L6 20V5a1 1 0 0 1 1-1z",
  clock: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM12 8v4.5l3 2",
  activity: "M4 12h3.5l2-5 4 10 2-5H20",
  warning: "M12 4.5 20.5 19h-17zM12 10v4M12 16.5v.01",
  templates: "M5 4.5h6v6H5zM13 4.5h6v6h-6zM5 13.5h6v6H5zM13 16.5h6",
  chat: "M5 5.5h14a1 1 0 0 1 1 1V15a1 1 0 0 1-1 1h-8l-4 3.5V16H5a1 1 0 0 1-1-1V6.5a1 1 0 0 1 1-1z",
  key: "M14.5 10.5a4 4 0 1 0-3.9 3.1L9 15.2V17H7v2H4.5v-2.5l5.6-5.6M15.5 7.5v.01",
};

export function Icon({ name, title }: { name: string; title?: string }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden={title ? undefined : true} role={title ? "img" : undefined}>
      {title && <title>{title}</title>}
      <path d={paths[name] ?? paths.dot} />
    </svg>
  );
}
